import React, { FC } from 'react'
import { Tab, Tabs } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useCoachOverviewRoute } from '../useCoachOverviewRoute'
import theme from '../../../../../../theme'

const CoachOverviwHeadTab: FC = () => {
	const [currentTabValue, coachRoutesData, handleChangeRoute] =
		useCoachOverviewRoute()

	return (
		<Tabs
			value={currentTabValue}
			onChange={handleChangeRoute}
			aria-label='Coach overview nav tabs'
			sx={{ ml: { xs: 0, xl: 8 }, mt: 6.5 }}
		>
			{coachRoutesData.map(route => (
				<Tab
					component={RouterLink}
					label={route.label}
					to={route.to}
					value={route.value}
					aria-label={route.ariaLabel}
					key={route.value}
					// disabled={route.disabled || false}
					sx={{
						mr: 12,
						px: 0,
						pb: 4.5,
						fontFamily: 'Gilroy-SemiBold, sans-serif',
						fontSize: '1.25rem',
						textTransform: 'capitalize',
						'&.MuiTab-textColorPrimary': {
							color: theme.palette.text.primary,
						},
						'&.Mui-selected': {
							color: theme.palette.primary.main,
						},
					}}
				/>
			))}
		</Tabs>
	)
}

export default CoachOverviwHeadTab
